module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.target === 0),
      expression: "target === 0"
    }],
    staticClass: "no-convertion"
  }, [_vm._m(0)]), _c('PageTitle', {
    attrs: {
      "pagetitle": "账户优化",
      "tip": "通过对您搜索推广账户进行问题诊断、问题原因分析给出优化建议，采纳建议将帮助您优化推广策略，提升广告推广及转化效果"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dianjingID),
      expression: "dianjingID"
    }],
    staticClass: "floatr btn btn-primary btn-custom",
    attrs: {
      "href": _vm.toOperateList,
      "target": "_blank"
    }
  }, [_vm._v("查看操作列表")]), (_vm.dianjingIDList.length > 0) ? _c('span', {
    staticClass: "floatr",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stop($event)
      }
    }
  }, [_c('label', [_vm._v("账号切换：")]), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dianjingID),
      expression: "dianjingID"
    }],
    attrs: {
      "options": _vm.dianjingIDList
    },
    domProps: {
      "value": (_vm.dianjingID)
    },
    on: {
      "input": function($event) {
        _vm.dianjingID = $event
      }
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "zone target-zone"
  }, [_c('p', [_vm._v("优化目标："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.target),
      expression: "target"
    }],
    attrs: {
      "name": "target",
      "options": _vm.targetList
    },
    domProps: {
      "value": (_vm.target)
    },
    on: {
      "input": function($event) {
        _vm.target = $event
      }
    }
  }), _c('v-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noConvertion),
      expression: "!noConvertion"
    }],
    attrs: {
      "tip": '您的网站已收集到转化数据，优先推荐使用优化转化效果模板，优化展现点击建议包含在其中。',
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1)]), _c('div', {
    staticClass: "opt-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.noConvertion && _vm.target == 1)),
      expression: "(noConvertion && target == 1)"
    }],
    staticClass: "no-convertion"
  }, [_c('div', {
    staticClass: "no-convertion-panel"
  }, [_c('img', {
    attrs: {
      "src": "https://p3.ssl.qhimg.com/t010462c200a27ad0b0.png"
    }
  }), _c('h3', [_vm._v("Ops! 暂无数据")]), _c('div', {
    staticClass: "p no-convertion-tip"
  }, [_vm._v("由于您的日均转化次数低于 20 或未"), _c('i', {
    staticClass: "link-opt"
  }, [_c('router-link', {
    attrs: {
      "to": '/setting/trans'
    }
  }, [_vm._v("设置转化目标")])], 1), _vm._v("，无法使用该优化目标进行账户优化")])])]), _c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.tabViews), function(item) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('div', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.currentView === item.comp
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.changeViewTo(item.comp)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  })), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'section'),
      expression: "currentView == 'section'"
    }],
    staticClass: "select-plan",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stop($event)
      }
    }
  }, [_vm._v("筛选待优化计划"), _c('v-tooltip', {
    attrs: {
      "tip": '按昨日数据进行筛选',
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "margin-left": "5px"
    }
  })]), _vm._v("："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectPlanMethod),
      expression: "selectPlanMethod"
    }],
    attrs: {
      "name": "method",
      "options": _vm.planMethods
    },
    domProps: {
      "value": (_vm.selectPlanMethod)
    },
    on: {
      "input": function($event) {
        _vm.selectPlanMethod = $event
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectPlanMethod == 4),
      expression: "selectPlanMethod == 4"
    }],
    staticClass: "custom-plan",
    slot: "4"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customPlanMethod != ''),
      expression: "customPlanMethod != ''"
    }],
    staticClass: "plan",
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.customPlanMethod
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editCustomPlanMethod($event)
      }
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customPlanMethod != ''),
      expression: "customPlanMethod != ''"
    }],
    staticClass: "fa fa-window-close-o",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.closeCustomPlanMethod($event)
      }
    }
  })])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectPlanMethod == 5),
      expression: "selectPlanMethod == 5"
    }],
    staticClass: "custom-plan",
    slot: "5"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.searchPlanShow && this.planList.length != 0),
      expression: "!searchPlanShow && this.planList.length != 0"
    }],
    staticClass: "btn btn-primary btn-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.searchPlanShow = true
      }
    }
  }, [_vm._v("重新选择")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchPlanShow),
      expression: "searchPlanShow"
    }],
    staticClass: "hand-custom-plan-select",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stop($event)
      }
    }
  }, [_c('i', {
    staticClass: "triangle"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planName),
      expression: "planName"
    }],
    staticClass: "search-plan",
    attrs: {
      "type": "text",
      "placeholder": "请输入搜索内容"
    },
    domProps: {
      "value": _vm._s(_vm.planName)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.getPlanList($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.planName = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getPlanList($event)
      }
    }
  }), _c('p', [_vm._v("已选" + _vm._s(_vm.planCheckedList.length) + "个（最多选20个计划）"), _c('span', {
    staticClass: "floatr btn btn-primary btn-icon",
    on: {
      "click": _vm.resetCheckPlanList
    }
  }, [_vm._v("全部清空")])]), _c('div', {
    staticClass: "plan-list"
  }, _vm._l((_vm.allPlanList), function(plan) {
    return _c('label', {
      staticClass: "label",
      attrs: {
        "title": plan.plan
      }
    }, [_c('v-checkbox', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (plan.checked),
        expression: "plan.checked"
      }],
      attrs: {
        "title": plan.plan
      },
      domProps: {
        "value": (plan.checked)
      },
      on: {
        "input": function($event) {
          plan.checked = $event
        }
      },
      nativeOn: {
        "change": function($event) {
          _vm.toggleCheckPlan(plan, $event)
        }
      }
    })], 1)
  })), _c('div', {
    staticClass: "btn-wrap tr"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.planMethodSubmit($event)
      }
    }
  }, [_vm._v("确认")]), _c('button', {
    staticClass: "btn btn-default btn-small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetPlanMethod($event)
      }
    }
  }, [_vm._v("取消")])])])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectPlanMethod == 4),
      expression: "selectPlanMethod == 4"
    }],
    staticClass: "custom-plan",
    slot: "4"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customPlanMethod == ''),
      expression: "customPlanMethod == ''"
    }],
    staticClass: "custom-plan-select",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stop($event)
      }
    }
  }, [_c('i', {
    staticClass: "triangle"
  }), _c('p', [_vm._v("自定义筛选Top20计划：")]), _c('p', [_c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planOrder),
      expression: "planOrder"
    }],
    attrs: {
      "options": _vm.planIndices
    },
    domProps: {
      "value": (_vm.planOrder)
    },
    on: {
      "input": function($event) {
        _vm.planOrder = $event
      }
    }
  }), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planIsasc),
      expression: "planIsasc"
    }],
    attrs: {
      "options": _vm.isascList
    },
    domProps: {
      "value": (_vm.planIsasc)
    },
    on: {
      "input": function($event) {
        _vm.planIsasc = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.planMethodSubmit($event)
      }
    }
  }, [_vm._v("确认")]), _c('button', {
    staticClass: "btn btn-default btn-small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetPlanMethod($event)
      }
    }
  }, [_vm._v("取消")])])])])], 1), _c('div', {
    staticClass: "zone opt-zone layout-defaultmg"
  }, [_vm._m(1), _c('div', {
    staticClass: "opt-tool-row"
  }, [_c('TimeSpan', {
    attrs: {
      "filters": _vm.timeSpanType,
      "custom": false
    },
    on: {
      "change": _vm.onTimespanChange
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planListShow && _vm.planList.length > 0),
      expression: "planListShow && planList.length >0"
    }],
    staticClass: "floatr mgtop6"
  }, [_c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planSelected),
      expression: "planSelected"
    }],
    attrs: {
      "options": _vm.planList
    },
    domProps: {
      "value": (_vm.planSelected)
    },
    on: {
      "input": function($event) {
        _vm.planSelected = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "floatr"
  }, [(_vm.currentChart == 'line') ? _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indiceSelected),
      expression: "indiceSelected"
    }],
    attrs: {
      "name": "indice",
      "options": _vm.indiceList
    },
    domProps: {
      "value": (_vm.indiceSelected)
    },
    on: {
      "input": function($event) {
        _vm.indiceSelected = $event
      }
    }
  }) : _vm._e(), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'overall' && _vm.target == 2),
      expression: "currentView == 'overall' && target == 2"
    }]
  }, [_c('button', {
    staticClass: "btn btn-white btn-small",
    class: {
      'btn-primary': _vm.currentChart == 'line'
    },
    on: {
      "click": function($event) {
        _vm.currentChart = 'line'
      }
    }
  }, [_vm._v("趋势图")]), _c('button', {
    staticClass: "btn btn-white",
    class: {
      'btn-primary': _vm.currentChart == 'quad'
    },
    on: {
      "click": function($event) {
        _vm.currentChart = 'quad'
      }
    }
  }, [_vm._v("四象限图")])])], 1)], 1), (_vm.currentChart == 'line') ? _c('pred-line-chart', {
    attrs: {
      "legend": _vm.legend,
      "xAxis": _vm.chartXAxis,
      "series": _vm.chartSeries,
      "predseries": _vm.predChartSeries,
      "lineXAxis": _vm.lineXAxis,
      "areaXAxis": _vm.areaXAxis
    }
  }) : _vm._e(), (_vm.currentChart == 'quad' && _vm.target == 2) ? _c('QuadChart', {
    attrs: {
      "listSeries": _vm.quadListSeries,
      "avgSeries": _vm.quadAvgSeries,
      "loading": _vm.quadLoading,
      "axisNames": _vm.quadNames
    },
    on: {
      "quadPosition": _vm.setQuadPosition
    }
  }) : _vm._e(), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chartTip),
      expression: "chartTip"
    }],
    staticClass: "chart-tip"
  }, [_vm._v(_vm._s(_vm.chartTip))])], 1), _c('div', {
    staticClass: "zone opt-zone layout-defaultmg"
  }, [_c('header', [_c('span', {
    staticClass: "title-icon analysis-exchange"
  }), _vm._v("问题诊断及优化建议"), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'overall' && _vm.target == 1 && _vm.dianjingID),
      expression: "currentView == 'overall' && target == 1 && dianjingID"
    }],
    staticClass: "floatr"
  }, [_c('span', {
    staticClass: "btn btn-icon"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _c('a', {
    attrs: {
      "href": _vm.toViewProcess,
      "target": "_blank"
    }
  }, [_vm._v("查看分析过程")])])])]), (_vm.currentView == 'overall') ? _c('div', {
    staticClass: "problem"
  }, [_vm._l((_vm.problems), function(problem, index) {
    return _c('div', {
      staticClass: "problem-item"
    }, [_c('span', {
      staticClass: "index-box f14",
      class: _vm.levelClassName(problem.level)
    }, [_vm._v(_vm._s(index + 1))]), _c('span', {
      staticClass: "f14"
    }, [_vm._v(_vm._s(problem.problemDesc))]), _c('ul', {
      staticClass: "advice-list"
    }, _vm._l((problem.advices), function(advice, adviceIndex) {
      return _c('li', {
        staticClass: "advice"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.adviceDefaultTip(advice))
        }
      }), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!advice.show && advice.module != 'landingPage'),
          expression: "!advice.show && advice.module != 'landingPage' "
        }]
      }, [_vm._v("（已采纳"), _c('i', {
        staticClass: "red"
      }, [_vm._v(" " + _vm._s(advice.act_suggest_num))]), _vm._v(" 个）")]), _c('v-tooltip', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (advice.prompt + ''),
          expression: "advice.prompt + ''"
        }],
        attrs: {
          "tip": advice.prompt + '',
          "pos": "right"
        }
      }, [_c('i', {
        staticClass: "fa fa-question-circle",
        staticStyle: {
          "margin-left": "5px"
        }
      })]), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!advice.show),
          expression: "!advice.show"
        }],
        staticClass: "floatr btn btn-icon",
        on: {
          "click": function($event) {
            _vm.openAdviceTable(advice)
          }
        }
      }, [_vm._v("查看详情"), _c('i', {
        staticClass: "fa fa-angle-double-right"
      })]), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (advice.show),
          expression: "advice.show"
        }],
        staticClass: "floatr btn btn-icon",
        on: {
          "click": function($event) {
            _vm.closeAdviceTable(advice)
          }
        }
      }, [_vm._v("收起"), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), (advice.show == true && _vm.adviceList.length == 0) ? _c('div', {
        staticClass: "reason-content"
      }, [_c('p', {
        staticClass: "center mg10"
      }, [_vm._v("今日推荐意见均已添加至操作列表模板，进入 "), _c('i', {
        staticClass: "link-opt"
      }, [_c('a', {
        attrs: {
          "href": _vm.toOperateList,
          "target": "_blank"
        }
      }, [_vm._v("操作列表")])]), _vm._v("可同步至点睛模板")])]) : _vm._e(), (advice.show == true && _vm.adviceList.length) ? _c('div', {
        staticClass: "reason-content"
      }, [(advice.module == 'service') ? _c('ServiceAdviceTable', {
        attrs: {
          "isAllChecked": !_vm.addToOptTableSucTipShow,
          "list": _vm.adviceList
        },
        on: {
          "pageChange": _vm.pageChange
        }
      }) : _vm._e(), (advice.module == 'kr') ? _c('KrAdviceTable', {
        attrs: {
          "isAllChecked": !_vm.addToOptTableSucTipShow,
          "list": _vm.adviceList
        },
        on: {
          "pageChange": _vm.pageChange
        }
      }) : _vm._e(), (advice.module == 'price') ? _c('PriceAdviceTable', {
        attrs: {
          "isAllChecked": !_vm.addToOptTableSucTipShow,
          "list": _vm.adviceList
        },
        on: {
          "pageChange": _vm.pageChange
        }
      }) : _vm._e(), (advice.module == 'krPause') ? _c('PauseAdviceTable', {
        attrs: {
          "isAllChecked": !_vm.addToOptTableSucTipShow,
          "list": _vm.adviceList
        },
        on: {
          "pageChange": _vm.pageChange
        }
      }) : _vm._e(), (advice.module == 'accountBudget' || advice.module == 'planBudget') ? _c('BudgetAdviceTable', {
        attrs: {
          "isAllChecked": !_vm.addToOptTableSucTipShow,
          "bgtype": advice.module == 'accountBudget' ? 'custname' : 'plan',
          "list": _vm.adviceList
        },
        on: {
          "pageChange": _vm.pageChange
        }
      }) : _vm._e(), (advice.module == 'landingPage') ? _c('LpAdviceTable', {
        attrs: {
          "list": _vm.adviceList,
          "isAllChecked": !_vm.addToOptTableSucTipShow,
          "hasCheckbox": false
        }
      }) : _vm._e(), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (advice.module != 'landingPage'),
          expression: "advice.module != 'landingPage'"
        }],
        staticClass: "button-wrapper"
      }, [_c('div', {
        staticClass: "btn btn-primary",
        on: {
          "click": function($event) {
            _vm.addToOptTable(advice)
          }
        }
      }, [_vm._v("添加至操作列表")]), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.addToOptTableSuccess),
          expression: "addToOptTableSuccess"
        }],
        staticClass: "add-opt-tip"
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.addToOptTableSucTipShow),
          expression: "!addToOptTableSucTipShow"
        }],
        staticClass: "fade-rocket-leave",
        attrs: {
          "src": "https://p5.ssl.qhimg.com/t018b5e325e0f47b754.png"
        }
      }), (_vm.addToOptTableSucTipShow) ? _c('span', [_vm._v("采纳的建议已添加至操作列表模板，进入 "), _c('i', {
        staticClass: "link-opt"
      }, [_c('a', {
        attrs: {
          "href": _vm.toOperateList,
          "target": "_blank"
        }
      }, [_vm._v("操作列表")])]), _vm._v("可同步至点睛模板")]) : _vm._e()])])], 1) : _vm._e()], 1)
    }))])
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.problems.length == 0),
      expression: "problems.length == 0"
    }],
    staticClass: "center"
  }, [_vm._v("暂无相关推荐")])], 2) : _vm._e(), (_vm.currentView == 'section') ? _c('div', {
    staticClass: "plan-problem section",
    attrs: {
      "id": 'section'
    }
  }, [_c('fold-table', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.sectionAdviceList
    },
    scopedSlots: {
      "opt-td": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!props.item.show),
            expression: "!props.item.show"
          }],
          staticClass: "btn btn-icon",
          on: {
            "click": function($event) {
              _vm.openPlanAdviceTable(props.item)
            }
          }
        }, [_vm._v("优化建议 "), _c('i', {
          staticClass: "fa fa-angle-double-right"
        })]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.item.show),
            expression: "props.item.show"
          }],
          staticClass: "btn btn-icon",
          on: {
            "click": function($event) {
              _vm.closePlanAdviceTable(props.item)
            }
          }
        }, [_vm._v("收起 "), _c('i', {
          staticClass: "fa fa-angle-down"
        })])]
      },
      "flod-tr": function(props) {
        return [_c('div', {
          staticClass: "problem-item"
        }, [_c('ul', {
          staticClass: "advice-list"
        }, _vm._l((props.item.problem), function(advice, adviceIndex) {
          return _c('li', {
            staticClass: "advice"
          }, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.adviceDefaultTip(advice))
            }
          }), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!advice.show && advice.module != 'landingPage'),
              expression: "!advice.show && advice.module != 'landingPage'"
            }]
          }, [_vm._v("（已采纳"), _c('i', {
            staticClass: "red"
          }, [_vm._v(" " + _vm._s(advice.act_suggest_num))]), _vm._v(" 个）")]), _c('v-tooltip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (advice.prompt + ''),
              expression: "advice.prompt + ''"
            }],
            attrs: {
              "tip": advice.prompt + '',
              "pos": "right"
            }
          }, [_c('i', {
            staticClass: "fa fa-question-circle",
            staticStyle: {
              "margin-left": "5px"
            }
          })]), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!advice.show),
              expression: "!advice.show"
            }],
            staticClass: "floatr btn btn-icon",
            on: {
              "click": function($event) {
                _vm.openAdviceTable(advice)
              }
            }
          }, [_vm._v("查看详情"), _c('i', {
            staticClass: "fa fa-angle-double-right"
          })]), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (advice.show),
              expression: "advice.show"
            }],
            staticClass: "floatr btn btn-icon",
            on: {
              "click": function($event) {
                _vm.closeAdviceTable(advice)
              }
            }
          }, [_vm._v("收起"), _c('i', {
            staticClass: "fa fa-angle-down"
          })]), (advice.show == true && _vm.adviceList.length == 0) ? _c('div', {
            staticClass: "reason-content"
          }, [_c('p', {
            staticClass: "center mg10"
          }, [_vm._v("今日推荐意见均已添加至操作列表模板，进入 "), _c('i', {
            staticClass: "link-opt"
          }, [_c('a', {
            attrs: {
              "href": _vm.toOperateList,
              "target": "_blank"
            }
          }, [_vm._v("操作列表")])]), _vm._v("可同步至点睛模板")])]) : _vm._e(), (advice.show == true && _vm.adviceList.length) ? _c('div', {
            staticClass: "reason-content"
          }, [(advice.module == 'service') ? _c('ServiceAdviceTable', {
            attrs: {
              "isAllChecked": !_vm.addToOptTableSucTipShow,
              "list": _vm.adviceList
            },
            on: {
              "pageChange": _vm.pageChange
            }
          }) : _vm._e(), (advice.module == 'kr') ? _c('KrAdviceTable', {
            attrs: {
              "isAllChecked": !_vm.addToOptTableSucTipShow,
              "list": _vm.adviceList
            },
            on: {
              "pageChange": _vm.pageChange
            }
          }) : _vm._e(), (advice.module == 'price') ? _c('PriceAdviceTable', {
            attrs: {
              "isAllChecked": !_vm.addToOptTableSucTipShow,
              "list": _vm.adviceList
            },
            on: {
              "pageChange": _vm.pageChange
            }
          }) : _vm._e(), (advice.module == 'krPause') ? _c('PauseAdviceTable', {
            attrs: {
              "isAllChecked": !_vm.addToOptTableSucTipShow,
              "list": _vm.adviceList
            },
            on: {
              "pageChange": _vm.pageChange
            }
          }) : _vm._e(), (advice.module == 'accountBudget' || advice.module == 'planBudget') ? _c('BudgetAdviceTable', {
            attrs: {
              "isAllChecked": !_vm.addToOptTableSucTipShow,
              "bgtype": advice.module == 'accountBudget' ? 'custname' : 'plan',
              "list": _vm.adviceList
            },
            on: {
              "pageChange": _vm.pageChange
            }
          }) : _vm._e(), (advice.module == 'landingPage') ? _c('LpAdviceTable', {
            attrs: {
              "isAllChecked": !_vm.addToOptTableSucTipShow,
              "list": _vm.adviceList,
              "hasCheckbox": false
            }
          }) : _vm._e(), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (advice.module != 'landingPage'),
              expression: "advice.module != 'landingPage'"
            }],
            staticClass: "button-wrapper"
          }, [_c('div', {
            staticClass: "btn btn-primary",
            on: {
              "click": function($event) {
                _vm.addToOptTable(advice)
              }
            }
          }, [_vm._v("添加至操作列表")]), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.addToOptTableSuccess),
              expression: "addToOptTableSuccess"
            }],
            staticClass: "add-opt-tip"
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.addToOptTableSucTipShow),
              expression: "!addToOptTableSucTipShow"
            }],
            staticClass: "fade-rocket-leave",
            attrs: {
              "src": "https://p5.ssl.qhimg.com/t018b5e325e0f47b754.png"
            }
          }), (_vm.addToOptTableSucTipShow) ? _c('span', [_vm._v("采纳的建议已添加至操作列表模板，进入 "), _c('i', {
            staticClass: "link-opt"
          }, [_c('a', {
            attrs: {
              "href": '/web/operatelist',
              "target": "_blank"
            }
          }, [_vm._v("操作列表")])]), _vm._v("可同步至点睛模板")]) : _vm._e()])])], 1) : _vm._e()], 1)
        }))])]
      }
    }
  })], 1) : _vm._e()]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'overall' && _vm.hasConvertionFlag),
      expression: "currentView == 'overall' && hasConvertionFlag"
    }],
    staticClass: "problem-tip"
  }, [_vm._v("说明： 红色图标为急需采纳的建议，灰色图标为持续优化需采纳的建议")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "src": _vm.logsrc
    }
  }), _c('v-modal', {
    attrs: {
      "visible": _vm.emptyPlanAdviceShow,
      "title": ''
    },
    on: {
      "closemodal": function($event) {
        _vm.emptyPlanAdviceShow = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-bd public-modal"
  }, [_c('div', {
    staticClass: "msg-wrap"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-exclamation-triangle icon icon-warn"
  }), _c('span', [_vm._v("暂无优化建议，可能原因如下：")])]), _c('p', [_vm._v("1、按照您的筛选规则，账户内没有相应计划。")]), _c('p', [_vm._v("2、筛选出的计划昨日推广数据较少。")])]), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.emptyPlanAdviceShow = false
      }
    }
  }, [_vm._v("确认")])])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-convertion-panel"
  }, [_c('img', {
    attrs: {
      "src": "https://p3.ssl.qhimg.com/t010462c200a27ad0b0.png"
    }
  }), _c('h3', [_vm._v("开发中，请耐心等待...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('span', {
    staticClass: "title-icon analysis-pie"
  }), _vm._v("数据分析")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59aad674", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59aad674!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/optimizeaccount.vue
// module id = 756
// module chunks = 0